'use client'

import React from 'react'
import type { NextPage } from 'next'
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Container } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'
import { Linker } from 'src/Components/Ui/Linker'

const Legal: NextPage = () => {
  const { t } = useLocale()

  const legalInfo = [
    {
      item: '販売業者名',
      content: '株式会社ATOMS（ATOMS, inc）'
    },
    {
      item: '責任者氏名',
      content: '代表取締役社長 石川 佳和'
    },
    {
      item: '所在地',
      content: '〒633-0067 奈良県桜井市大福156-4'
    },
    {
      item: '電話番号',
      content: '0744-46-5181'
    },
    {
      item: 'メールアドレス',
      content: 'atoms.sns@gmail.com'
    },
    {
      item: 'お問い合わせ',
      content: (
        <a href="https://atoms-inc.com/contact/" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline' }}>
          https://atoms-inc.com/contact/
        </a>
      )
    },
    {
      item: 'お支払い方法',
      content: 'クレジットカード, Apple Pay'
    },
    {
      item: '商品代金以外の必要料金',
      content: '送料：全国一律1,100円（税込)'
    },
    {
      item: '消費税',
      content: '全ての商品の表示価格は、消費税込みの価格となります。'
    },
    {
      item: '返品・キャンセルについて',
      content:
        '受注生産のため、ご注文後のキャンセル・返品はお受けできません。\n\n商品はご注文後に製造いたします。お客様のご都合による返品・交換はいたしかねます。'
    },
    {
      item: '引き渡し時期',
      content: '通常、発注完了後から3ヶ月でのご納品となります。\n※繁忙期にはご納品にお時間を頂戴する場合がございます。'
    }
  ]

  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
          特定商取引法に基づく表記
        </Typography>

        <Box mb={4}>
          <Typography variant="body1" paragraph>
            特定商取引法に基づき、以下の通り表記いたします。
          </Typography>
        </Box>

        <TableContainer component={Paper} sx={{ mb: 4 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', width: '30%' }}>項目</TableCell>
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>内容</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {legalInfo.map((info, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>{info.item}</TableCell>
                  <TableCell sx={{ whiteSpace: 'pre-line' }}>{info.content}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box textAlign="center" mt={4}>
          <Linker href="/">
            <Typography variant="body2" color="primary" sx={{ textDecoration: 'underline' }}>
              トップページに戻る
            </Typography>
          </Linker>
        </Box>
      </Box>
    </Container>
  )
}

export default Legal
